import AddIcon from '@material-ui/icons/Add';

export default AddIcon;
